require('./bootstrap');
require('./_global');
require('./components/vue-declarator');



// WEBPACK FOOTER //
// ./resources/js/app/main.js